import {inject, Injectable} from '@angular/core';
import {Order} from '@features/sales/domain/entities/order/order.entity';
import {OrderStore} from './order.store';
import {OrderQueryService} from './order-query.service';

@Injectable({providedIn: 'root'})
export class OrderCommandService {
  private readonly orders = inject(OrderStore);
  private readonly query = inject(OrderQueryService);

  save(order: Order): void {
    this.persist(order);
  }

  markPending(orderId: string): void {
    this.update(orderId, (order) => order.markPending());
  }

  markProcessing(orderId: string): void {
    this.update(orderId, (order) => order.markProcessing());
  }

  settle(orderId: string): void {
    this.update(orderId, (order) => order.settle());
  }

  markFailed(orderId: string): void {
    this.update(orderId, (order) => order.markFailed());
  }

  remove(orderId: string): void {
    this.orders.removeOrder(orderId);
  }

  reset(): void {
    this.orders.reset();
  }

  private update(orderId: string, mutate: (order: Order) => void): void {
    const order = this.query.findById(orderId);

    if (!order) {
      return;
    }

    mutate(order);
    this.persist(order);
  }

  private persist(order: Order): void {
    this.orders.saveOrder(order.toDTO());
  }
}
